import { SearchQuery } from "shared/data/reducers/types/storage";
import FlightOffer from "shared/types/flightOffer";

import { isDefaultSelectedFilterMatch } from "../defaultSelectedFilters";

const filterAirportsMobile = (
  oFlightOffer: FlightOffer,
  searchQuery: SearchQuery
) => {
  if (
    !isDefaultSelectedFilterMatch(
      searchQuery.airports_from,
      oFlightOffer.FlightItinerary.FlightStream[0][0].FlightSegments
        .FlightSegment[0].OriginAirport
    )
  ) {
    return false;
  }

  if (searchQuery.airports_to) {
    const destinationAirport =
      oFlightOffer.FlightItinerary.FlightStream[0][0].FlightSegments
        .FlightSegment[
        oFlightOffer.FlightItinerary.FlightStream[0][0].FlightSegments
          .FlightSegment.length - 1
      ].DestinationAirport;

    if (
      !isDefaultSelectedFilterMatch(searchQuery.airports_to, destinationAirport)
    ) {
      return false;
    }
  }

  if (
    searchQuery.airports_transfers &&
    searchQuery.airports_transfers !== "all"
  ) {
    const aTransfersInThisFlight = oFlightOffer.FlightItinerary.FlightStream[0][0].FlightSegments.FlightSegment.filter(
      (_oFlightSegment, index) => {
        if (
          index ===
          oFlightOffer.FlightItinerary.FlightStream[0][0].FlightSegments
            .FlightSegment.length -
            1
        ) {
          return false;
        }
        return true;
      }
    ).map((oFlightSegment) => oFlightSegment.DestinationAirport);

    if (!aTransfersInThisFlight.includes(searchQuery.airports_transfers)) {
      return false;
    }
  }

  return true;
};

export default filterAirportsMobile;
